module.exports = __webpack_public_path__ + "static/img/1_3.796d098.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new/1_3.png
// module id = djDO
// module chunks = 0